module.exports = __webpack_public_path__ + "media/images/plans/plan-icon-table-flower-c77fcd3793f35b57c0c4c93f219a6147.png";